var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { active: _vm.showInstaller, "can-cancel": false, scroll: "keep" },
      on: {
        "update:active": function ($event) {
          _vm.showInstaller = $event
        },
        close: _vm.cancelar,
      },
    },
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-content" }, [
          _c("h1", { staticClass: "title is-4" }, [
            _c("i", { staticClass: "fas fa-cube" }),
            _vm._v(" Instalación: Administración"),
          ]),
          _vm._v(" "),
          _c("h1", { staticClass: "subtitle is-6" }, [
            _vm._v("Configuración de parametros"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "notification is-primary" }, [
              _c("i", { staticClass: "fas fa-info-circle fa-fw" }),
              _vm._v(" Recuerde asignar los roles "),
              _c("span", { staticClass: "tag is-white is-rounded" }, [
                _vm._v("Administrador"),
              ]),
              _vm._v(" a los usuarios.\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field is-clearfix" }, [
            _c("div", { staticClass: "buttons is-pulled-right" }, [
              _c(
                "button",
                {
                  staticClass: "button is-dark is-outlined",
                  on: { click: _vm.cancelar },
                },
                [_vm._v("\n            Cancelar\n          ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  attrs: { disabled: _vm.errors.count() > 0 },
                  on: { click: _vm.instalar },
                },
                [_vm._v("\n            Instalar módulo\n          ")]
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }